/**
 * @memberof module:compressed-json.constants
 * @namespace Prefixes
 */
'use strict'

/** @lends module:compressed-json.constants.Prefixes */
const Prefixes = {
  POINTER_PREFIX: 'p:',
  ESCAPED_PREFIX:'e:',
}

module.exports = Prefixes
